import { useState, useEffect, useRef } from 'react'

import { Link, useHref } from 'react-router-dom'

//Components
import TooltipIcon from '../elements/tooltip-icon'
import FormattedDate from '../elements/formatted-date'
import NotLoggedMessage from '../elements/not_logged_message'

import CustomDropdown from '../elements/input/custom-dropdown'
import CustomTagBox from '../elements/input/custom-tagbox'
import FavoriteButton from '../elements/button/favorite-button'
import CustomPopup from '../elements/custom-popup'
import ActionButton from '../elements/button/action-button'
import CancelButton from '../elements/button/secondary-action-button'
import Loading from '../controls/loading'

//dev-extreme
import { Gallery } from 'devextreme-react/gallery';

//constant
import { AMENITIES_PARKING, AMENITIES_POOL } from '../../../constant/amenities'
import { BUILDING_TYPES_NAMES } from '../../../constant/building-types'
//Images
import RenovatedImage from '../../../images/renovated.png'
import FloorImage from '../../../images/floor plan.png'
import LocationImage from '../../../images/location.png'
import RadiusImage from '../../../images/location_radius.png'
import PetAllowedImage from '../../../images/pets_friendly.png'
import PoolImage from '../../../images/swimmingpool.png'
import ParkingImage from '../../../images/parking.png'
import { ReactComponent as CartIcon } from '../../../images/cart-icon.svg'

//utils
import { isLoggedIn } from '../../../utils/user'
import { postPropertyToCart, putPropertyToCart, deletePropertyInCart } from '../../../utils/property-card'


//styles
import '../styles/property-card.css'
import baseService from '../../../services/base.service'
import { SHOW_RATES } from '../../../constant/settings'

const PropertyCard = ({ data, reference, isSelected, onHover, likeAProperty, unLikeAProperty, cardType, reverseType, addToCart, addToCartPopup, hideDistance, gallery, noAbsolute, loading }) => {
  const galleryRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [floor, setFloor] = useState('')
  const [floorPopup, setFloorPopup] = useState([])
  const [isWarningVisible, setIsWarningVisible] = useState(false)
  const [resetWarningVisible, setResetWarningVisible] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const [floorsDescription, setFloorsDescription] = useState('')
  const [amenitiesFound, setAmenitiesFound] = useState({
    pool: false,
    parking: false
  })
  const [isAddedToCart, setIsAddedToCart] = useState(false)
  const checkIfaddedToCart = async (propertyId) => {
    if (propertyId) {
      let result = await checkIfInCart(propertyId)
      setFloorPopup(result)
      setIsAddedToCart(result.length > 0)
      let floors = []
      data.floorPlans.forEach((floor, index) => {
        if (result.includes(floor.id))
          floors.push(<><span className='green-text'>{floor.name}</span>{index === data.floorPlans.length - 1 ? '' : ','}</>)
        else
          floors.push(<><span>{floor.name}</span>{index === data.floorPlans.length - 1 ? '' : ','}</>)
      }
      )
      if (floors.length > 0)
        setFloorsDescription(floors)
      else
        setFloorsDescription('All Floor Plans')
    }
  }
  const postAddToCartPopUp = async _ => {
    if (isLoggedIn()) {
      if (isAddedToCart) {
        if (floorPopup.length > 0) {
          await putPropertyToCart(floorPopup, data.id)
          setIsAddedToCart(true)
        }
        else {
          await deletePropertyInCart(data.id)
          setIsAddedToCart(false)
        }
      }
      else {
        await postPropertyToCart(floorPopup, data.id)
        setIsAddedToCart(true)
      }
      await checkIfaddedToCart(data.id)
      setIsVisible(false)
    }
    else {
      setResetWarningVisible(!resetWarningVisible)
      setIsWarningVisible(true)
    }
  }
  const checkIfInCart = async (propertyId) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart/check-if-added?propertyId=${propertyId}`;
    return await baseService.get(url, {
      method: 'GET',
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin': `${process.env.PUBLIC_URL}`,
        'Content-Type': 'application/json',
      }
    }).then(({ data }) => {
      return data
    })
  }

  const handleGalleryClick = e => {
    if (e.target.closest('.dx-gallery-nav-button-prev,.dx-gallery-nav-button-next')) {
      e.preventDefault()
      e.stopPropagation()
    }

  }

  useEffect(() => {
    let foundPool = data?.amenities?.some(amenity => AMENITIES_POOL.includes(amenity.id))
    let foundParking = data?.amenities?.some(amenity => AMENITIES_PARKING.includes(amenity.id))
    setAmenitiesFound({
      pool: foundPool,
      parking: foundParking
    })
  }, [data])
  useEffect(() => {
    const checkIfaddedToCartLocal = async () => {
      await checkIfaddedToCart(data.id);
    }
    if (isLoggedIn()) {
      checkIfaddedToCartLocal()
    }
    else {
      let floors = []
      data.floorPlans.forEach(floor => floors.push(floor.name))
      if (floors.length > 0)
        setFloorsDescription(floors.join(','))
      else
        setFloorsDescription('All Floor Plans')
    }

  }, [data.id]);
  useEffect(() => {
    if (galleryRef.current) {
      galleryRef.current.instance.repaint()
    }
  }, [cardType])

  const itemTemplate = (e) => {
    return <img src={cardType === 'square' ? e.imageSrc : e.imageSrcSmall} alt={e.imageAlt} loading='lazy' />
  }

  return (
    <div style={{ position: 'relative', width: '100%' }} className={`${noAbsolute ? 'custom-card__wrapper--no-absolute' : 'custom-card__wrapper'} ${floorPopup.length > 0 ? 'custom-card__wrapper--green-border' : ''}`}>
      <Link className={`${cardType === 'square' ? 'custom-card--square' : 'custom-card'} ${isSelected ? (cardType === 'square' ? 'custom-card--square--selected' : 'custom-card--selected') : ''} ${addToCart ? (cardType === 'square' ? 'custom-card--square--addToCart' : 'custom-card--addToCart') : ''} ${addToCartPopup ? (cardType === 'square' ? 'custom-card--square--addToCartPopup' : 'custom-card--addToCartPopup') : ''}`} ref={reference} to={`/property/dashboard/${data.metisId}`} onMouseEnter={onHover ? () => onHover(data.id) : () => { }} target='_blank'>
        <div className='custom-card__image'>
          {
            gallery ?
              <div className='custom-card__image__wrapper' onClick={handleGalleryClick}>
                <Gallery
                  ref={galleryRef}
                  id={`gallery${data.id}`}
                  dataSource={data.sliceImages}
                  itemRender={itemTemplate}
                  loop={true}
                  showNavButtons={true}
                  showIndicator={true}
                />
              </div>
              :
              <img src={data.imageUrl}
                style={{
                  backgroundImage: `url(${data.imageUrl})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  textIndent: '-10000px'
                }}
              // height={90} width={135}
              />
          }
          {cardType === 'square' && SHOW_RATES &&
            <div className='custom-card__price'>
              {data.rate ? <><span className='custom-card__price__cursive'>from</span><span className='custom-card__price__one-line'><span className='custom-card__price__bigger'>${data.rate.toFixed(2)}</span><span className='custom-card__price__cursive'>/night</span></span></> : <span className='custom-card__price__bigger'>On Request</span>}
            </div>
          }
        </div>
        {/* <div className='custom-card__title' style={data.metisId !== data.id ? {color: 'red'} : {color: 'green'}}><span>{`Property #${data.metisId}`}</span>{cardType !== 'square' && <span>{data.recentlyRenovated && <TooltipIcon id={`renovated_${data.id}`} image={RenovatedImage} label={<FormattedDate fdate={data.dateOfRenovation}/>}/>}</span>}</div> */}
        <div className='custom-card__title'><span>{`Property #${data.metisId}`}</span>{cardType !== 'square' && <span>{data.recentlyRenovated && <TooltipIcon id={`renovated_${data.id}`} image={RenovatedImage} label={<FormattedDate fdate={data.dateOfRenovation} />} />}</span>}</div>
        <div className='custom-card__description'>
          {cardType !== 'square' && <div className='custom-card__description__location'><img src={LocationImage} alt='location img' /><div className='custom-card__description__location__text'>{data.formattedAddress.replace(/,\s*,/g, ', ').replace(/^,/, '')}</div></div>}
          {/* {cardType !== 'square' && <div className='custom-card__description__location'><img src={LocationImage} alt='location img'/><div className='custom-card__description__location__text'>{data.formattedAddress.replace(/\s+/g,'').replace(/,{2,}/g,',')}</div></div>} */}
          {!hideDistance && <div className='custom-card__description__radius'><img src={RadiusImage} alt='radius img' width='17px' height='17px' /><span className='custom-card__description__radius__text'>{cardType === 'square' ? 'Distance: ' : ''}{data.distanceInMiles.toFixed(2)} Miles.</span></div>}
          {/* {cardType !== 'square' && <div><img src={FloorImage} alt='floor img' width='17px' height='17px'/>{floorsDescription}</div>}            */}
        </div>
        <div className='custom-card__floorplans'><img src={FloorImage} alt='floor img' /><div className='custom-card__floorplans__text'>{floorsDescription}</div></div>
        <div className={`custom-card__includes ${reverseType ? 'custom-card__includes--reverse' : ''}`}>
          {(amenitiesFound.pool || amenitiesFound.parking || data.petsAllowed) &&
            <div className='custom-card__includes__amenities'>
              {amenitiesFound.pool && <TooltipIcon id={`pool_${data.id}`} image={PoolImage} label={'Swimming Pool'} />}
              {amenitiesFound.parking && <TooltipIcon id={`parking_${data.id}`} image={ParkingImage} label={'Parking'} />}
              {data.petsAllowed && <TooltipIcon id={`petAllowed_${data.id}`} image={PetAllowedImage} label={'Pets Friendly'} />}
            </div>
          }
          <div className='custom-card__includes__building-type'>{BUILDING_TYPES_NAMES.filter(item => item.id == data.buildingTypeId)[0]?.[cardType === 'square' ? 'shortName' : 'longName']}</div>
        </div>
        {
          addToCartPopup && !data.isViewOnly &&
          <div className='custom-card__addToCartPopup' onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}>
            {
              // !isAddedToCart ?
              <div className={`custom-card__addToCart__floor__button ${isAddedToCart ? 'custom-card__addToCart__floor__button--green' : ''}`} onClick={_ => setIsVisible(true)}><span>{isAddedToCart ? 'Edit' : 'Add to Cart'}</span> <CartIcon /> </div>
              // :
              // <div className='custom-card__addToCart__floor__button button__red' onClick={deleteFomCart}>Remove from cart</div>

            }
            {/*<div className='custom-card__addToCart__floor__button' onClick={_=>setIsVisible(true)}><span>Add to Cart</span> <CartIcon/> </div>*/}

          </div>
        }
        <div className='custom-card__favorite'>
          {cardType === 'square' && <span>{data.recentlyRenovated && <TooltipIcon id={`renovated_${data.id}`} image={RenovatedImage} label={<FormattedDate fdate={data.dateOfRenovation} />} />}</span>}
          <FavoriteButton key={data.id} metisId={data.metisId} propertyId={data.id} isLiked={data.isLiked} likeAProperty={likeAProperty} unLikeAProperty={unLikeAProperty} cardType={cardType} />
        </div>
        {cardType !== 'square' && SHOW_RATES && <div className='custom-card__price'>{data.rate ? <><span className='custom-card__price__cursive'>from</span><span className='custom-card__price__one-line'><span className='custom-card__price__bigger'>${data.rate.toFixed(2)}</span><span className='custom-card__price__cursive'>/night</span></span></> : <span className='custom-card__price__bigger'>On Request</span>}
        </div>}
      </Link>
      <CustomPopup visible={isVisible} onHiding={_ => setIsVisible(false)} closeOnlyButtons={true}>
        <div className='custom-card__modal'>
          <div className='custom-card__modal__title'>Add Property #{data.metisId} to the cart</div>
          <div className='custom-card__modal__message'>To add Property #{data.metisId} to the cart, please choose the floor plan you are interested in (you can choose few variants to check which one is available):</div>
          <div className='custom-card__modal__dropdown'>
            <CustomTagBox
              label='Floor plan'
              values={data.floorPlans}
              value={floorPopup}
              setValue={setFloorPopup}
              requiredValue={isAddedToCart && floorPopup.length <= 0 ? false : true}
              placeholder='Floor Plan' />
          </div>
          <div className={`custom-card__modal__buttons ${isAddedToCart && floorPopup.length <= 0 ? 'custom-card__modal__buttons--red' : ''}`}>
            <ActionButton disabled={floorPopup.length <= 0 && !isAddedToCart || loading} action={postAddToCartPopUp}>{!isAddedToCart ? 'Add to cart' : (isAddedToCart && floorPopup.length <= 0 ? 'Remove from cart' : 'Update cart')}</ActionButton>
            <CancelButton disabled={loading} action={_ => setIsVisible(false)}>Cancel</CancelButton>
            <Loading isVisble={loading} />
          </div>
        </div>
      </CustomPopup>
      <NotLoggedMessage
        message='to add property to the cart'
        visible={isWarningVisible}
        setVisible={setIsWarningVisible}
        resetTrigger={resetWarningVisible}
      />
    </div>

  )
}

export default PropertyCard